import "./polyfills";
import React from "react";
import * as Sentry from "@sentry/browser";
import { createRoot } from "react-dom/client";
import * as Analytics from "./analytics";
import App from "./App";
import { setGlobalEnvironmentVariables } from "./environment";
import { injectGlobals } from "./styles";
import "@hooplab/ui-components/dist/style.css";
import "./tailwind.css";

setGlobalEnvironmentVariables(window.env);

if (window.ENVIRONMENT.__SENTRY_DSN__) {
  Sentry.init({
    dsn: window.ENVIRONMENT.__SENTRY_DSN__,
    environment: window.ENVIRONMENT.environment,
    ignoreErrors: [
      "Non-Error promise rejection captured",
      "ResizeObserver loop limit exceeded",
      "ResizeObserver loop completed with undelivered notifications.",
    ],
  });
}

Analytics.initialize();
injectGlobals();

const container = document.getElementById("root");
const root = createRoot(container!);
root.render(<App />);
